import React, { useMemo } from 'react';
import { ColorPickerField } from '../../../components/Form';
import { useFocusIdx } from '@bay-email/editor';

export function BackgroundColor({
  title = t('Background color'),
  supportsDynamic = true,
}: {
  title?: string;
  supportsDynamic?: boolean;
}) {
  const { focusIdx } = useFocusIdx();

  return useMemo(() => {
    return (
      <ColorPickerField
        label={title}
        name={`${focusIdx}.attributes.background-color`}
        supportsDynamic={supportsDynamic}
      />
    );
  }, [focusIdx, title, supportsDynamic]);
}
